var n = /* @__PURE__ */ ((a) => (a[a.Mainnet = 1] = "Mainnet", a[a.Optimism = 10] = "Optimism", a[a.Matic = 137] = "Matic", a[a.Base = 8453] = "Base", a[a.Sepolia = 11155111] = "Sepolia", a[a.Shape = 360] = "Shape", a[a.ApeChain = 33139] = "ApeChain", a))(n || {});
const t = {
  1: {
    rpcUrls: ["https://mainnet.infura.io"],
    chainName: "Ethereum Mainnet",
    displayName: "Ethereum",
    alternateNames: ["mainnet", "eth"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18
    },
    // @todo: we should really just match the chains.json structure here and do an array of structs
    blockExplorerUrls: ["https://etherscan.io"]
  },
  10: {
    rpcUrls: ["https://mainnet.optimism.io/"],
    chainName: "Optimism Mainnet",
    displayName: "Optimism",
    alternateNames: ["op", "oeth"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "OETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://optimistic.etherscan.io/"]
  },
  8453: {
    rpcUrls: ["https://mainnet.base.org"],
    chainName: "Base Mainnet",
    displayName: "Base",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://basescan.org"]
  },
  137: {
    rpcUrls: ["https://polygon-rpc.com"],
    chainName: "Polygon Mainnet",
    displayName: "Polygon",
    alternateNames: ["matic", "pol"],
    nativeCurrency: {
      name: "POL",
      symbol: "POL",
      decimals: 18
    },
    blockExplorerUrls: ["https://polygonscan.com"]
  },
  360: {
    rpcUrls: ["https://mainnet.shape.network"],
    chainName: "Shape Mainnet",
    displayName: "Shape",
    alternateNames: [],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://shapescan.xyz/"]
  },
  33139: {
    rpcUrls: ["https://rpc.apechain.com"],
    chainName: "ApeChain Mainnet",
    displayName: "ApeChain",
    alternateNames: ["ape", "apechain"],
    nativeCurrency: {
      name: "ApeChain",
      symbol: "APE",
      decimals: 18
    },
    blockExplorerUrls: ["https://apescan.io/"]
  },
  11155111: {
    rpcUrls: ["https://rpc.sepolia.org"],
    chainName: "Ethereum Testnet Sepolia",
    displayName: "Sepolia",
    alternateNames: ["sep"],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18
    },
    blockExplorerUrls: ["https://sepolia.etherscan.io"]
  }
}, r = [
  11155111
  /* Sepolia */
], i = Object.keys(t).map((a) => parseInt(a)), p = (a) => i.includes(a);
function l(a, s = !1) {
  if (!p(a))
    throw new Error("Unsupported Network");
  const e = t[a];
  return s ? e.displayName : e.displayName.toLowerCase();
}
function m(a) {
  return r.includes(a);
}
export {
  n as N,
  i as S,
  r as T,
  p as a,
  t as b,
  l as g,
  m as i
};
//# sourceMappingURL=network-BRHI3AkZ.es.js.map
